import { inject, Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot,RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@services/auth.service';
import  { Observable, of } from 'rxjs';
import { distinctUntilChanged, takeUntil, debounceTime, filter,tap, switchMap, delay, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AccountInfo, EventMessage, EventType, InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import {
  MsalService,
  MsalModule,
  MsalBroadcastService,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
} from '@azure/msal-angular';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private msalBroadcastService: MsalBroadcastService
  ) {}



    canActivate(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
    ): Observable<boolean>|Promise<boolean>|boolean {

        return this.msalBroadcastService.inProgress$.pipe(
                filter((status: InteractionStatus) => status === InteractionStatus.None),
                switchMap(() => {
                  if (this.authService.isAuthenticated()) {
                    return of(true);
                  }

                  this.authService.loginRedirect(window.location.origin + state.url);
                  return of(false);
                })
              );

      // let isAuthenticated = this.authService.isAuthenticated();
      // return isAuthenticated;
      // if (!isAuthenticated) {
      //   // this.router.navigate(['auth']);
      //   this.authService.loginRedirect();
      // }

      // return true;
    }


}
